import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=460fc3e6&"
import script from "./RegistrationModal.vue?vue&type=script&lang=ts&"
export * from "./RegistrationModal.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports